import { useContext } from 'react'

import Context from './Context'

const useViewport = () => {
  return useContext(Context)
}

export default useViewport
